import { orderBy } from "es-toolkit";

import type { InteractModuleListItem } from "@skilitics/nautilus-endpoint-definition";

import type { OrderingDirection } from "../types.ts";

export const createByTitle = (orderingDirection: OrderingDirection) => (modules: InteractModuleListItem[]) =>
  modules
    ? orderBy(modules, [({ title }) => title.toLowerCase()], [orderingDirection === "ascending" ? "asc" : "desc"])
    : [];
